import fetch from 'isomorphic-fetch';
import i18n from 'i18next';
import Fetch from 'i18next-fetch-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const options = {
  fallbackLng: 'en',
  ns: ['core'],
  defaultNS: 'core',

  // debug: true,
  // The default keySeparator is '.' This setting enables to use '.' inside a key.

  keySeparator: false,
  backend: {
    loadPath: `${process.env.REACT_APP_LOKALISE_HOST}/{{lng}}/{{ns}}.json`,
    referenceLng: 'en',
    requestOptions: {
      cache: 'no-cache',
    },
    fetch,
  },

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
    format(value, format) {
      if (format === 'uppercase') return value.toUpperCase();
      return value;
    },
  },
  react: {
    wait: process && !process.release,
  },
};

// for browser use http backend to load translations and browser lng detector
if (process && !process.release) {
  i18n
    .use(Fetch)
    .use(LanguageDetector);
}

// initialize if not already initialized
if (!i18n.isInitialized) {
  i18n.init(options);
}

export default i18n;



// WEBPACK FOOTER //
// ../src/i18n.js